export const VESSEL_QUERY = `
query (
  $id: ID!
  $i18nLanguage: String
)
@i18n(
  language: $i18nLanguage
) {
  vessel (
    id: $id
  ) {
    id
    company {
      id
      name
    }
    description {
      value
    }
    image {
      url
    }
    name {
      value
    }
    sizes {
      id
      name {
        value
      }
      maxGroupSize
      pricePerHourInCents
    }
  }
}
`

export const VESSEL_LIST_QUERY = `
query (
  $i18nLanguage: String
  $filters: [FilterInput]
) @i18n (
  language: $i18nLanguage
) {
  vesselList (
    filters: $filters
  ) {
    id
    name {
      value
    }
    company {
      id
      name
    }
    sizes {
      id
      name {
        value
      }
      maxGroupSize
      pricePerHourInCents
    }
  }
}
`

export const VESSELS_QUERY = `
query (
  $filters: [FilterInput]
  $i18nLanguage: String
  $pageNumber: Int
  $pageSize: Int
  $sorting: [SortingInput]
)
@i18n (
  language: $i18nLanguage
) {
  vessels (
    filters: $filters
    pageNumber: $pageNumber
    pageSize: $pageSize
    sorting: $sorting
  ) {
    data {
      id
      company {
        name
      }
      name {
        value
      }
      createdAt
      updatedAt
    }
    total
  }
}
`
